import { render, staticRenderFns } from "./ReviewWords.vue?vue&type=template&id=288df32e"
import script from "./ReviewWords.vue?vue&type=script&lang=js"
export * from "./ReviewWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports